/**
 * A call's length as people say it: "45 s", "3 min 26 s", "1 h 02 min".
 *
 * Seconds are rounded, never truncated, so a 105.091 s call reads "1 min 45 s".
 */
export function formatDuration(ms: number | null): string {
  if (ms === null || !Number.isFinite(ms) || ms < 0) return '—';

  const total = Math.round(ms / 1000);
  if (total < 60) return `${String(total)} s`;

  const minutes = Math.floor(total / 60);
  const seconds = total % 60;
  if (minutes < 60) return `${String(minutes)} min ${String(seconds).padStart(2, '0')} s`;

  const hours = Math.floor(minutes / 60);
  return `${String(hours)} h ${String(minutes % 60).padStart(2, '0')} min`;
}
